module.exports = __webpack_public_path__ + "img/align-right-01.af3df900.svg";